module.exports = __webpack_public_path__ + "img/v1.ab8220a7.png";